import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './lib/router'
import { $src, $public } from './lib/utils'

const app = createApp(App)
const head = createHead()
const pinia = createPinia()

app.use(head)
app.use(pinia)
app.use(router)

// Global image include
app.config.globalProperties.$public = $public
app.config.globalProperties.$src = $src

app.mount('#app')

setTimeout(() => {
	document.dispatchEvent(new Event('prerender-complete'))
},3000)
